(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    // Autoplay videos in product cards when they enter the viewport
  (function () {
    if (typeof IntersectionObserver === 'undefined') return;

    function initCardVideoAutoplay() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const deferredMedia = entry.target;

            if (entry.isIntersecting) {
              // Si el video nativo todavía no fue inyectado desde el <template>, lo inyectamos
              const existingVideo = deferredMedia.querySelector('video');
              const existingIframe = deferredMedia.querySelector('iframe');

              if (!existingVideo && !existingIframe) {
                const template = deferredMedia.querySelector('template');
                if (template) {
                  deferredMedia.appendChild(template.content.cloneNode(true));
                }
              }

              // Play
              const video = deferredMedia.querySelector('video');
              if (video) {
                video.muted = true;
                video.play().catch(() => {});
              }
            } else {
              // Pause cuando la card sale del viewport
              const video = deferredMedia.querySelector('video');
              if (video) video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );

      // Observar solo los deferred-media dentro de product cards (no los de páginas de producto)
      document
        .querySelectorAll('.product-grid__item deferred-media[autoplay]')
        .forEach((el) => observer.observe(el));
    }

    // Ejecutar cuando el DOM esté listo
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCardVideoAutoplay);
    } else {
      initCardVideoAutoplay();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
